import {classes} from '@/util';
import styles from './style.module.css';

import LogoIcon from './icons/logo.svg?react';
import LogoCircleIcon from './icons/logo-circle.svg?react';
import CarouselArrowLeftIcon from './icons/icon-carousel-arrow-left.svg?react';
import CarouselArrowRightIcon from './icons/icon-carousel-arrow-right.svg?react';
import CubeViewIcon from './icons/icon-cube-view.svg?react';
import RevertIcon from './icons/icon-revert.svg?react';
import ViewModeIcon from './icons/icon-view-mode.svg?react';

const ICON_MAP = {
    logo: LogoIcon,
    'logo-circle': LogoCircleIcon,
    'carousel-arrow-left': CarouselArrowLeftIcon,
    'carousel-arrow-right': CarouselArrowRightIcon,
    'cube-view': CubeViewIcon,
    revert: RevertIcon,
    'view-mode': ViewModeIcon,
} as const;

export type IconName = keyof typeof ICON_MAP;

export interface SvgIconProps {
    name: IconName;
    className?: string;
    size?: number | string;
    width?: number | string;
    height?: number | string;
    color?: string;
    title?: string;
    'aria-hidden'?: boolean;
}

export function SvgIcon({
    name,
    className,
    size,
    width,
    height,
    color,
    title,
    'aria-hidden': ariaHidden = false,
}: SvgIconProps) {
    const IconComponent = ICON_MAP[name];

    if (!IconComponent) {
        console.warn(`SvgIcon: Icon "${name}" not found`);

        return null;
    }

    const w = width ?? size ?? 24;
    const h = height ?? size ?? 24;

    const iconProps = {
        className: classes(
            styles.svgIcon,
            color && styles[`color-${color}`],
            className
        ),
        width: w,
        height: h,
        'aria-hidden': ariaHidden,
        ...(title && !ariaHidden ? {'aria-label': title} : {}),
        ...(title ? {title} : {}),
    };

    return <IconComponent {...iconProps} />;
}
